import { useEffect, useMemo } from 'react';
import { useSettings } from '../../core/contexts/SettingsContext';
import localApiAdapter from '../../core/services/localApiAdapter';
import {
  DEFAULT_VENTES_CONFIG,
  normalizeVentesConfig,
  buildVentesEntityPrefixes,
} from './ventesConfigDefaults';

let hydratePromise = null;

function hydrateVentesConfig(patchSettings, existingSettings) {
  if (!hydratePromise) {
    hydratePromise = localApiAdapter
      .get('/ventes/config')
      .then((response) => {
        const raw = response?.data !== undefined ? response.data : response;
        const normalized = normalizeVentesConfig(raw || {});
        syncVentesConfigToSettings(normalized, patchSettings, existingSettings);
        return normalized;
      })
      .catch(() => {
        hydratePromise = null;
        return DEFAULT_VENTES_CONFIG;
      });
  }
  return hydratePromise;
}

/** Live ventes module config — synced from API once, then from SettingsContext. */
export function useVentesConfig() {
  const { settings, patchSettings } = useSettings();

  useEffect(() => {
    if (settings?.ventes && Object.keys(settings.ventes).length > 0) return;
    void hydrateVentesConfig(patchSettings, settings);
  }, [settings?.ventes, settings, patchSettings]);

  return useMemo(
    () => normalizeVentesConfig(settings?.ventes || {}),
    [settings?.ventes],
  );
}

export function syncVentesConfigToSettings(config, patchSettings, existingSettings) {
  const normalized = normalizeVentesConfig(config);
  patchSettings({
    ventes: normalized,
    configuration: {
      entityPrefixes: {
        ...(existingSettings?.configuration?.entityPrefixes || {}),
        ...buildVentesEntityPrefixes(normalized),
      },
    },
  }, { persist: false });
  return normalized;
}
